import React from 'react';
import './EmptyTableText.scss';

const EmptyTableText = ({ text }) => (
    <div className="core--empty-table-text" >
        <span>{text || ''}</span>
    </div>
);

export default EmptyTableText;
